
import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import './Checkbox.css'

const Checkbox = props => {
  // if you need a radio button, use the <Radio> wrapper in ../radio
  const { name, value, onChange, onInvalid, initialChecked, size, secondary, isRadio, isDisabled, required } = props

  const classes = classnames({
    'ui-Checkbox': true,
    'ui-Checkbox--secondary': secondary,
    [`ui-Checkbox--${size}`]: size
  })

  const attrs = {
    onChange: onChange,
    onInvalid: onInvalid,
    defaultChecked: initialChecked,
    type: isRadio ? 'radio' : 'checkbox',
    className: classes,
    value: value,
    name: name,
    disabled: isDisabled,
    required: required
  }

  return <input {...attrs} />
}

Checkbox.defaultProps = {
  onChange: () => {},
  onInvalid: () => {}
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onInvalid: PropTypes.func.isRequired,
  initialChecked: PropTypes.bool.isRequired,
  size: PropTypes.string,
  secondary: PropTypes.string,
  isRadio: PropTypes.bool,
  isDisabled: PropTypes.bool,
  required: PropTypes.string
}

Checkbox.displayName = 'Checkbox'

export default Checkbox



// WEBPACK FOOTER //
// ./ui/Checkbox.js